import { WELCOME } from "@/content/ministry";
import { SITE } from "@/config/site";
import { useParallax } from "@/hooks/useMotion";
import { Link } from "@/router/Router";
import { Container } from "@/components/ui/Primitives";
import { PhotoSlot } from "@/components/ui/PhotoSlot";
import { Reveal } from "@/components/motion/Reveal";
import { Icon } from "@/components/ui/Icon";

/** Editorial welcome: people-first photography beside "God values you. You are important to us." */
export function Welcome() {
  const back = useParallax<HTMLDivElement>(0.05);
  const front = useParallax<HTMLDivElement>(0.12);
  return (
    <section className="welcome" aria-labelledby="welcome-title">
      <Container>
        <div className="welcome__grid">
          <div className="welcome__photos">
            <div ref={back} className="welcome__photo welcome__photo--back">
              <Reveal variant="clip">
                <PhotoSlot src="/media/home/welcome-worship.jpg" alt="Worship at Miracle Assembly" label="Worship" />
              </Reveal>
            </div>
            <div ref={front} className="welcome__photo welcome__photo--front">
              <Reveal variant="clip" delay={160}>
                <PhotoSlot src="/media/home/welcome-family.jpg" alt="Members of the Quality Living Tribe" label="Family" tone="flame" />
              </Reveal>
            </div>
            <Reveal className="welcome__badge" delay={260}>
              <span className="welcome__badge-num">1</span>
              <span>
                visit
                <br />
                changes everything
              </span>
            </Reveal>
          </div>
          <div className="welcome__text">
            <Reveal>
              <span className="rule" aria-hidden />
            </Reveal>
            <h2 id="welcome-title" className="welcome__title">
              <Reveal as="span" className="welcome__line">
                {WELCOME.lead}
              </Reveal>
              <Reveal as="span" className="welcome__line welcome__line--em" delay={120}>
                {WELCOME.second}
              </Reveal>
            </h2>
            <Reveal delay={180}>
              <p className="welcome__body">{WELCOME.body}</p>
            </Reveal>
            <Reveal delay={220}>
              <p className="welcome__sign">
                — {SITE.pastor}, Senior Pastor
              </p>
            </Reveal>
            <Reveal delay={260} className="welcome__links">
              <Link to="/about" className="hero-btn hero-btn--outline hero-btn--theme">
                Discover Miracle Assembly
              </Link>
              <Link to="/new" className="text-link">
                I'm new here <Icon name="arrowRight" size={15} />
              </Link>
            </Reveal>
          </div>
        </div>
      </Container>
    </section>
  );
}
